import React from "react";

const ImageSourceCaption = ({ sourceText }) => {
    return (
        <figcaption>
            {sourceText ? <span>Image source: {sourceText}</span> : <span>AI generated image using <a href="https://copilot.microsoft.com/" target="_blank">Microsoft Copilot</a>.</span>

            }
        </figcaption>
    )
};

export default ImageSourceCaption;